import { IGNORE_ROUTES } from '@/constants/analitics.js'

const GTAG_ID = 'G-T8M239J0XR'
const YANDEX_METRIKA_ID = 93736397
const TOP_MAIL_ID = '3748362'
const TOP_MAIL_SCRIPT_ID = 'tmr-code'
const FIRST_INTERACTION_EVENTS = ['pointerdown', 'keydown', 'touchstart', 'scroll']

const isMobileViewport = () => window.matchMedia && window.matchMedia('(max-width: 767px)').matches

const appendScript = ({ id, src }) => {
  if (document.getElementById(id)) return

  const script = document.createElement('script')
  script.id = id
  script.async = true
  script.src = src
  document.head.appendChild(script)
}

const scheduleIdle = (callback, timeout) => {
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(callback, { timeout })
    return
  }

  window.setTimeout(callback, timeout)
}

const initYandexMetrika = () => {
  if (window.__vistatYandexMetrikaInitialized) return

  window.__vistatYandexMetrikaInitialized = true
  window.ym(YANDEX_METRIKA_ID, 'init', {
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    webvisor: true,
    defer: true,
  })
}

export default ({ app, env }, inject) => {
  if (env.isStaging) {
    inject('gtag', () => {})
    return
  }

  window.dataLayer = window.dataLayer || []
  window.gtag = window.gtag || function gtag() {
    window.dataLayer.push(arguments)
  }
  window.ym = window.ym || function ym() {
    window.ym.a = window.ym.a || []
    window.ym.a.push(arguments)
  }
  window.ym.l = window.ym.l || Number(new Date())

  let loaded = false
  let scheduled = false
  const pendingGtagEvents = []

  inject('gtag', (...args) => {
    if (loaded) {
      window.gtag(...args)
      return
    }

    pendingGtagEvents.push(args)
  })

  const canLoadForRoute = currentRoute => !IGNORE_ROUTES.includes(currentRoute.name)

  const loadAnalytics = () => {
    if (loaded) return

    if (!canLoadForRoute(app.router.currentRoute)) {
      scheduled = false
      return
    }

    loaded = true

    window.gtag('js', new Date())
    window.gtag('config', GTAG_ID, { send_page_view: false })
    window.gtag('event', 'page_view', { page_path: app.router.currentRoute.fullPath })
    pendingGtagEvents.forEach(args => window.gtag(...args))
    pendingGtagEvents.length = 0

    appendScript({
      id: 'gtag-js',
      src: `https://www.googletagmanager.com/gtag/js?id=${GTAG_ID}`,
    })

    window._tmr = window._tmr || []
    window._tmr.push({
      id: TOP_MAIL_ID,
      type: 'pageView',
      start: (new Date()).getTime(),
    })
    appendScript({
      id: TOP_MAIL_SCRIPT_ID,
      src: 'https://top-fwz1.mail.ru/js/code.js',
    })

    initYandexMetrika()
    appendScript({
      id: 'yandex-metrika-js',
      src: 'https://mc.yandex.ru/metrika/tag.js',
    })
  }

  const scheduleAnalytics = () => {
    if (scheduled || loaded || !canLoadForRoute(app.router.currentRoute)) return

    scheduled = true
    const timeout = isMobileViewport() ? 6000 : 3000

    scheduleIdle(loadAnalytics, timeout)

    FIRST_INTERACTION_EVENTS.forEach((eventName) => {
      window.addEventListener(eventName, loadAnalytics, {
        once: true,
        passive: true,
      })
    })
  }

  app.router.onReady(scheduleAnalytics)
  app.router.afterEach((to) => {
    if (canLoadForRoute(to)) {
      scheduleAnalytics()
    }
  })
}
